import {Bubble, Conversations, Prompts, Sender, useXAgent, useXChat, Welcome,} from '@ant-design/x';
import React, {ReactNode, useEffect, useMemo, useState} from 'react';
import {cloneDeep} from 'lodash';
import {SyncOutlined} from '@ant-design/icons';
import {Dropdown, type GetProp, MenuProps, message as Toast, Modal, Space} from 'antd';
import {useTranslation} from "react-i18next";
import {useRootSelector} from '../../../hooks';
import {baseUrl, ChatRequestBody, ChatResp, EventType, ModelItemType, ModelType, ModelTypeID, URL} from '../../../api';
import './index.scss';
import {Markdown} from "../../../components";
import {Assistant_New_Questions} from "../../../utils/defaultQuestions";
import Avatar from '../../../assets/images/avatar.png';
import AILogo from '../../../assets/images/ai-logo-grey.png';
import AILogoRed from '../../../assets/images/ai-logo.png';
import AIAssistantLogo from '../../../assets/images/ai-assistant/logo.png';
import AIAvatar from '../../../assets/images/ai-avatar-assistant.png';
import AIAvatarParty from '../../../assets/images/ai-avatar-party.png';
import AIAvatarAssistant from '../../../assets/images/ai-assistant/avatar.png';
import AgentMan from '../../../assets/images/ai-avatar-assistant_bg.png';
import AgentAssistantBG from '../../../assets/images/ai-assistant/avatar-bg.gif';
import AgentPartyBG from '../../../assets/images/ai-avatar-party-bg.gif';
import {getValueByProp} from "../../../utils/cu";

const description: any = {
    [ModelType.POLICY_PAPERS]: '您好！在这里，您可以找到关于辅导员岗位能力要求、政策法规、职业发展等相关文件和解读。',
    [ModelType.IDEOLOGICAL_VALUES]: '您好！在这里，您可以获取丰富的思想政治教育理论、方法和案例，帮助您更好地开展学生的思想引领工作。',
    [ModelType.CAUCUS_CLASSES]: '您好！在这里，您可以找到党团组织建设的规范流程、班级管理的实用方法以及丰富的活动案例，助力您打造优秀的党团组织和班级集体。',
    [ModelType.STUDENT_ACADEMICS]: '您好！在这里，您可以找到学业规划、学习方法指导、学术竞赛辅导等方面的知识和资源，助力您为学生提供精准的学业支持。',
    [ModelType.EVERYDAY_MATTERS]: '您好！在这里，您可以找到学生宿舍管理、奖助学金评定、学籍管理等方面的知识和操作流程，帮助您高效处理日常事务，确保学生管理工作顺利进行。',
    [ModelType.MENTAL_HEALTH]: '您好！在这里，您可以找到心理健康教育的理论知识、咨询技巧以及危机干预的方法，助力您为学生提供专业的心理支持。',
    [ModelType.INTERNET_IDEOLOGY_AND_POLITICS]: '您好！在这里，您可以找到网络思想政治教育的策略、新媒体平台运用技巧以及网络舆情应对方法，帮助您在网络空间开展有效的思想政治教育工作。',
    [ModelType.CRISIS_EVENTS]: '您好！在这里，您可以找到危机事件的预防、预警机制，以及应对突发事件的流程和方法，帮助您在危机面前保持冷静，妥善处理',
    [ModelType.EMPLOYMENT_AND_ENTREPRENEURSHIP]: '您好！在这里，您可以找到职业规划的方法、就业市场的分析、简历撰写指导以及面试技巧等内容，助力您为学生的职业发展提供全方位的支持。',
    [ModelType.SCIENTIFIC_RESEARCH_CAPABILITIES]: '您好！在这里，您可以找到辅导员工作的理论研究成果、实践案例分析以及研究方法指导，帮助您在工作中不断探索和创新，提升工作质量和水平。',
    [ModelType.ASSISTANT_PARTNER]: '老师，您好！欢迎来到示范班！我是您的智能学伴。关于本次培训的相关情况，您可以随时跟我交流哟！',
    [ModelType.POLICY_NAV]: '老师，您好！想要快速了解政策新动向，让我来帮您吧！',
    [ModelType.CAUCUS_JOB]: '老师，您好！党务工作很关键，更多党务知识和工作方法，我们一起交流哟！',
    [ModelType.MORAL_EDUCATION_JOB]: '老师，您好！德育是塑造灵魂的事业，很荣幸能成为您开展德育工作的助手！',
    [ModelType.CLASSES_MANAGE]: '老师，您好！面对即将到来的主题班会，您是否还在为设计新颖的班会方案而烦恼？我能助您快速找到灵感，设计出更具吸引力和教育意义的主题班会哟！',
    [ModelType.MENTAL_HEALTH_NEW]: '老师，您好！您既要关注学生的学业发展，又要留意他们的心理动态，一定很辛苦吧！让我来帮您开展心育工作吧！',
    [ModelType.PROFESSIONAL_COMPETENCE]: '老师，您好！您想获取更多支持资源吗？我会为您提供很多工具性的“智慧锦囊”哟！',
    [ModelType.CUSTOMER_SERVICE_ASSISTANT]: '老师，您好！欢迎来到示范班！我是您的智能学伴。关于本次培训的相关情况，您可以随时跟我交流哟！',
    [ModelType.COMMUNIST_PARTY_SECRETARY]: '老师，您好！欢迎来到2025年全国高校基层党组织书记网络培训示范班！我是您的AI班主任。关于本次培训的相关情况，您可以随时跟我交流哦！',
    [ModelType.LABOR_EDUCATION]: '老师，您好！我能为您提供劳动教育课程建设、活动设计、实践创新等方面的帮助哟！',
    [ModelType.NO_AUTH]: <div>您可以访问“<a
        href={URL.login + encodeURIComponent(window.location.href)}>https://study.enaea.edu.cn/</a>”或点击左下角的【登录按钮】
    </div>,
};
const placeholderPromptsItems: any = Assistant_New_Questions;
type CatAIIconType = {
    type: 0 | 1 | 2;
};
const CatAIIcon = (props: CatAIIconType) => {
    return useMemo(() => {
        const img = props.type === 1 ? AIAvatarAssistant : props.type === 2 ? AIAvatarParty : AIAvatar;
        return <span className={'welcome-icon'}>
    <img src={img} alt={'ai'}/>
</span>;
    }, [props.type]);
};

type PromptsType = {
    id?: string;
    message?: string;
};
const {confirm} = Modal;
export type Props = {
    modelType?: ModelType;
    modelTypeId?: ModelTypeID;
    showLogin?: boolean;
};
const Chats: React.FC<Props> = (props: Props) => {
    const {t} = useTranslation();
    const userInfo = useRootSelector(state => state.enaea?.userinfo);
    const defaultConversationsItems = localStorage.getItem('conversation-list-assistant') || JSON.stringify([]);
    const conversationsItemsList = JSON.parse(defaultConversationsItems);
    const defaultConversationsItem = {
        key: String(Math.floor(Math.random() * 10240)),
        id: '',
        conversation_id: '',
        label: t('newConversation'),
        type: props.modelType || ModelType.POLICY_PAPERS,
        //@ts-ignore
        typeId: props.modelTypeId || ModelTypeID.ASSISTANT_NEW,
        senderPromptsItems: [],
        message: []
    };
    const [content, setContent] = React.useState('');
    const [conversationsItems, setConversationsItems] = React.useState(conversationsItemsList);
    const [currentConversation, setCurrentConversation] = useState<typeof defaultConversationsItem>(cloneDeep(defaultConversationsItem));
    const [activeKey, setActiveKey] = React.useState<string | undefined>('');
    const [prompts, setPrompts] = useState<PromptsType | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [currentMsg, setCurrentMsg] = useState({
        message: '',
        status: '',
        id: '',
        message_id: '',
        conversation_id: '',
        conversation_key: '',
        type: ''
    });
    const roles: GetProp<typeof Bubble.List, 'roles'> = {
        ai: {
            placement: 'start',
            avatar: {
                icon: <CatAIIcon
                    type={props.modelTypeId === ModelTypeID.CUSTOMER_SERVICE_ASSISTANT ? 1 : props.modelTypeId === ModelTypeID.COMMUNIST_PARTY_SECRETARY ? 2 : 0}/>
            },
            styles: {
                content: {
                    borderRadius: 16,
                }
            },
        },
        local: {
            avatar: {
                icon: <img src={Avatar} alt={''}/>
            },
            placement: 'end',
            variant: 'borderless',
            footer: null
        },
    };
    const [isFirst, setIsFirst] = useState<boolean>(true);
    const modelList: ModelItemType[] = props.modelTypeId === ModelTypeID.CUSTOMER_SERVICE_ASSISTANT ? [
        {
            id: ModelType.CUSTOMER_SERVICE_ASSISTANT,
            key: ModelType.CUSTOMER_SERVICE_ASSISTANT,
            message: t('modelType.customer_service_assistant'),
            class: 'iconfont icon-Frame2',
            type: ModelType.CUSTOMER_SERVICE_ASSISTANT,
            modelTypeId: ModelTypeID.CUSTOMER_SERVICE_ASSISTANT
        },
        {
            id: ModelType.POLICY_NAV,
            key: ModelType.POLICY_NAV,
            message: t('modelType.policy_nav'),
            class: 'iconfont icon-zhengcewenjiandaohang',
            type: ModelType.POLICY_NAV,
            modelTypeId: ModelTypeID.HEAD_TEACHER_NEW
        },
        {
            id: ModelType.CAUCUS_JOB,
            key: ModelType.CAUCUS_JOB,
            message: t('modelType.caucus_job'),
            class: 'iconfont icon-richangshiwuguanli',
            type: ModelType.CAUCUS_JOB,
            modelTypeId: ModelTypeID.HEAD_TEACHER_NEW
        },
        {
            id: ModelType.MORAL_EDUCATION_JOB,
            key: ModelType.MORAL_EDUCATION_JOB,
            message: t('modelType.moral_education_job'),
            class: 'iconfont icon-deyugongzuo',
            type: ModelType.MORAL_EDUCATION_JOB,
            modelTypeId: ModelTypeID.HEAD_TEACHER_NEW
        },
        {
            id: ModelType.LABOR_EDUCATION,
            key: ModelType.LABOR_EDUCATION,
            message: t('modelType.labor_education'),
            class: 'iconfont icon-laodongjiaoyu',
            type: ModelType.LABOR_EDUCATION,
            modelTypeId: ModelTypeID.HEAD_TEACHER_NEW
        },
        {
            id: ModelType.CLASSES_MANAGE,
            key: ModelType.CLASSES_MANAGE,
            message: t('modelType.classes_manage'),
            class: 'iconfont icon-dangtuanbanjijianshe',
            type: ModelType.CLASSES_MANAGE,
            modelTypeId: ModelTypeID.HEAD_TEACHER_NEW
        },
        {
            id: ModelType.MENTAL_HEALTH_NEW,
            key: ModelType.MENTAL_HEALTH_NEW,
            message: t('modelType.mental_health_new'),
            class: 'iconfont icon-xinlijiankangfudao',
            type: ModelType.MENTAL_HEALTH_NEW,
            modelTypeId: ModelTypeID.HEAD_TEACHER_NEW
        },
        {
            id: ModelType.PROFESSIONAL_COMPETENCE,
            key: ModelType.PROFESSIONAL_COMPETENCE,
            message: t('modelType.professional_competence'),
            class: 'iconfont icon-jiuyechuangyezhidao',
            type: ModelType.PROFESSIONAL_COMPETENCE,
            modelTypeId: ModelTypeID.HEAD_TEACHER_NEW
        }
    ] : props.modelTypeId === ModelTypeID.COMMUNIST_PARTY_SECRETARY ? [{
        id: ModelType.COMMUNIST_PARTY_SECRETARY,
        key: ModelType.COMMUNIST_PARTY_SECRETARY,
        message: t('modelType.customer_service_assistant'),
        class: 'iconfont icon-Frame2',
        type: ModelType.COMMUNIST_PARTY_SECRETARY,
        modelTypeId: ModelTypeID.COMMUNIST_PARTY_SECRETARY
    }] : [
        {
            id: ModelType.POLICY_PAPERS,
            key: ModelType.POLICY_PAPERS,
            message: t('modelType.policy_papers'),
            class: 'iconfont icon-zhengcewenjiandaohang',
            type: ModelType.POLICY_PAPERS,
            modelTypeId: ModelTypeID.ASSISTANT_NEW
        },
        {
            id: ModelType.IDEOLOGICAL_VALUES,
            key: ModelType.IDEOLOGICAL_VALUES,
            message: t('modelType.ideological_values'),
            class: 'iconfont icon-sixiangjiazhiyinling',
            type: ModelType.IDEOLOGICAL_VALUES,
            modelTypeId: ModelTypeID.ASSISTANT_NEW
        },
        {
            id: ModelType.CAUCUS_CLASSES,
            key: ModelType.CAUCUS_CLASSES,
            message: t('modelType.caucus_classes'),
            class: 'iconfont icon-dangtuanbanjijianshe',
            type: ModelType.CAUCUS_CLASSES,
            modelTypeId: ModelTypeID.ASSISTANT_NEW
        },
        {
            id: ModelType.STUDENT_ACADEMICS,
            key: ModelType.STUDENT_ACADEMICS,
            message: t('modelType.student_academics'),
            class: 'iconfont icon-xueshengxueyezhidao',
            type: ModelType.STUDENT_ACADEMICS,
            modelTypeId: ModelTypeID.ASSISTANT_NEW
        },
        {
            id: ModelType.EVERYDAY_MATTERS,
            key: ModelType.EVERYDAY_MATTERS,
            message: t('modelType.everyday_matters'),
            type: ModelType.EVERYDAY_MATTERS,
            modelTypeId: ModelTypeID.ASSISTANT_NEW,
            class: 'iconfont icon-richangshiwuguanli',
        },
        {
            id: ModelType.MENTAL_HEALTH,
            key: ModelType.MENTAL_HEALTH,
            message: t('modelType.mental_health'),
            type: ModelType.MENTAL_HEALTH,
            class: 'iconfont icon-xinlijiankangfudao',
            modelTypeId: ModelTypeID.ASSISTANT_NEW
        },
        {
            id: ModelType.INTERNET_IDEOLOGY_AND_POLITICS,
            key: ModelType.INTERNET_IDEOLOGY_AND_POLITICS,
            message: t('modelType.internet_ideology_and_politics'),
            type: ModelType.INTERNET_IDEOLOGY_AND_POLITICS,
            class: 'iconfont icon-wangluosizhenggongzuo',
            modelTypeId: ModelTypeID.ASSISTANT_NEW
        },
        {
            id: ModelType.CRISIS_EVENTS,
            key: ModelType.CRISIS_EVENTS,
            message: t('modelType.crisis_events'),
            type: ModelType.CRISIS_EVENTS,
            class: 'iconfont icon-weijishijianyingdui',
            modelTypeId: ModelTypeID.ASSISTANT_NEW
        },
        {
            id: ModelType.EMPLOYMENT_AND_ENTREPRENEURSHIP,
            key: ModelType.EMPLOYMENT_AND_ENTREPRENEURSHIP,
            message: t('modelType.employment_and_entrepreneurship'),
            type: ModelType.EMPLOYMENT_AND_ENTREPRENEURSHIP,
            class: 'iconfont icon-jiuyechuangyezhidao',
            modelTypeId: ModelTypeID.ASSISTANT_NEW
        },
        {
            id: ModelType.SCIENTIFIC_RESEARCH_CAPABILITIES,
            key: ModelType.SCIENTIFIC_RESEARCH_CAPABILITIES,
            message: t('modelType.scientific_research_capabilities'),
            type: ModelType.SCIENTIFIC_RESEARCH_CAPABILITIES,
            class: 'iconfont icon-keyannenglitisheng',
            modelTypeId: ModelTypeID.ASSISTANT_NEW
        }
    ];
    // ==================== Runtime ====================
    const [agent] = useXAgent<{ data: string }>({
        baseURL: baseUrl + '/chat'
    });
    const [clickCurrentModel, setClickCurrentModel] = useState<ModelType | null>(props.modelType || ModelType.POLICY_PAPERS);
    const confirmHandle = (title: ReactNode, content: ReactNode, onOk: () => void) => {
        confirm({
            getContainer: () => document.querySelector('.enaea_layout') as HTMLElement,
            wrapClassName: 'delete-modal',
            title,
            centered: true,
            icon: null,
            content,
            okText: '确认',
            cancelText: '取消',
            autoFocusButton: null,
            onOk
        });
    };

    const {messages, setMessages} = useXChat({
        agent,
    });
    useEffect(() => {
        setPrompts(null);
    }, []);

    const saveAndUpdateConversation = (messages: any[]) => {
        if (!messages.length) return;
        const newConversationsItems = cloneDeep(conversationsItems);
        if (!isFirst && !newConversationsItems.find((item: any) => item.key === currentConversation.key)) {
            currentConversation.label = messages[0].message;
            newConversationsItems.unshift(currentConversation);
        }
        let flag = false;
        for (const item of newConversationsItems) {
            if (item.key === currentConversation.key) {
                const cloneItem = cloneDeep(item);
                item.message = messages;
                cloneItem.message = messages.map(({
                                                      id,
                                                      message,
                                                      status,
                                                      role,
                                                      message_id,
                                                      conversation_id,
                                                      type,
                                                      query,
                                                      auth
                                                  }, index) => ({
                    key: id,
                    loading: status === 'loading',
                    role: role === 'local' ? 'local' : 'ai',
                    content: message,
                    message_id: message_id,
                    id: message_id,
                    conversation_id: conversation_id,
                    footer: role === 'local' ? null :
                        status === 'complete' && auth !== 'none' ?
                            <div className={'re-sync'} style={loading ? {visibility: 'hidden'} : {}} onClick={() => {
                                if (messages[index - 1] && messages[index - 1].id) {
                                    setLoading(true);
                                    setCurrentMsg({
                                        message: '',
                                        status: '',
                                        id: '',
                                        message_id: '',
                                        conversation_id: '',
                                        conversation_key: '',
                                        type: '',
                                    });
                                    createRequest(query || messages[index - 1].message as string, id, '', type);
                                    return Toast.info(t('success'));
                                }
                                return Toast.info(t('fail'));
                            }}>
                                <SyncOutlined
                                    style={{cursor: 'pointer'}}/><span>{t('generation')}</span>
                            </div> : null,
                    messageRender: (message: string) => {
                        if (auth === 'none') {
                            return <Prompts className={'no-auth-message'}
                                            title={<div>您可以访问“<a
                                                href={URL.login + encodeURIComponent(window.location.href)}>https://study.enaea.edu.cn/</a>”或点击左下角的【登录按钮】
                                            </div>} items={[]}
                                            vertical/>;
                        }
                        if ((item.typeId || item.type) && role !== 'local') {
                            return <Markdown content={message}/>;
                        }
                        return message;
                    }
                }));
                flag = true;
                setCurrentConversation(cloneItem);
                break;
            }
        }
        if (flag) {
            localStorage.setItem('conversation-list-assistant', JSON.stringify(newConversationsItems));
            setConversationsItems(newConversationsItems);
        }
    }
    useEffect(() => {
        if (messages && currentConversation) {
            saveAndUpdateConversation(messages);
        }
    }, [messages]);

    const updateChatStatus = (id: string, resultMsg: string, state: string, message_id: string, conversation_id: string) => {
        const cloneMessages = cloneDeep(messages);
        const {status, result} = getValueByProp('id', id, cloneMessages);
        if (status) {
            result.message = resultMsg;
            result.message_id = message_id;
            result.conversation_id = conversation_id;
            result.status = state;
            setMessages(cloneMessages);
        }
    };
    useEffect(() => {
        if (currentMsg.message) {
            updateChatStatus(currentMsg.id, currentMsg.message, currentMsg.status, currentMsg.message_id, currentMsg.conversation_id);
            //@ts-ignore
            if (currentMsg.conversation_key) {
                let flag = false;
                const cloneConversationsItems = cloneDeep(conversationsItems);
                for (const item of cloneConversationsItems) {
                    //@ts-ignore
                    if (item.key === currentMsg.conversation_key) {
                        if (currentMsg.conversation_id) {
                            item.conversation_id = currentMsg.conversation_id;
                            item.id = currentMsg.conversation_id;
                            flag = true;
                        } else {
                            item.conversation_id = '';
                            item.id = '';
                        }
                        break;
                    }
                }
                if (flag) setConversationsItems(cloneConversationsItems);
            }
        }
    }, [currentMsg]);
    const createRequest = (msg: string, nextId: string, sourceId?: string, toolId?: string) => {
        let messageResult = '',
            agent_id = currentConversation?.typeId,
            tool_id = toolId || prompts?.id || '',
            conversation_id = currentConversation?.conversation_id || '',
            deep_think = true,
            web_search = true,
            conversation_key = currentConversation.key;
        const body: ChatRequestBody = {
            query: msg,
            agent_id,
            tool_id,
            user_id: userInfo.username || '',
            conversation_id,
            stream: true,
            deep_think,
            web_search
        };
        agent.request(body, {
            onSuccess: () => {
                setLoading(false);
            },
            onUpdate: (message) => {
                if (message.data) {
                    const data: ChatResp = JSON.parse(message.data);
                    if (data.conversation_id && !currentMsg.conversation_id) {
                        setCurrentMsg(prevState => {
                            if (!currentMsg.conversation_key) currentMsg.conversation_key = conversation_key;
                            prevState.conversation_id = data.conversation_id;
                            return prevState;
                        });
                    }
                    if (data.conversation_id && !currentConversation.conversation_id) {
                        setCurrentConversation(prevState => {
                            prevState.conversation_id = data.conversation_id;
                            prevState.id = data.conversation_id;
                            return prevState;
                        });
                    }
                    if (data.event === EventType.MESSAGE) {
                        //@ts-ignore
                        const isString = typeof data.answer === 'string';
                        //@ts-ignore
                        if (!isString && typeof data.answer === "object" && typeof data.answer?.content === 'string') {
                            //@ts-ignore
                            messageResult = data.answer?.content;
                        } else {
                            messageResult += data.answer;
                        }
                        setCurrentMsg({
                            id: nextId,
                            message: messageResult,
                            status: 'complete',
                            message_id: data.message_id,
                            conversation_id: data.conversation_id,
                            //@ts-ignore
                            conversation_key,
                            type: tool_id,
                        });
                    } else if (data.event === EventType.MESSAGE_END) {
                        setCurrentMsg({
                            id: nextId,
                            message_id: data.message_id,
                            conversation_id: data.conversation_id,
                            message: data.answer ? data.answer : messageResult,
                            //@ts-ignore
                            conversation_key,
                            status: 'complete',
                            type: tool_id,
                        });
                    }
                    //@ts-ignore
                } else if (message.hasOwnProperty('success') && !message.success) {
                    setLoading(false);
                    setCurrentMsg({
                        id: nextId,
                        message_id: '',
                        conversation_id: '',
                        //@ts-ignore
                        message: message.msg || t('fail'),
                        //@ts-ignore
                        conversation_key,
                        status: 'complete',
                        type: tool_id,
                    });
                }
            },
            onError: (error) => {
                console.error(error);
                setCurrentMsg({
                    id: nextId,
                    message_id: '',
                    conversation_id: '',
                    //@ts-ignore
                    conversation_key,
                    //@ts-ignore
                    message: error.msg || t('fail'),
                    status: 'error',
                    type: tool_id,
                });
                setLoading(false);
            }
        });
    }

    // ==================== Event ====================
    const onSubmit = (nextContent: string) => {
        if (!nextContent) return;
        setIsFirst(false);
        const len = messages.length;
        const nextId = 'msg_' + activeKey + (len + 1);
        const aiMessage = {
            //@ts-ignore
            role: "ai",
            //@ts-ignore
            status: 'loading',
            id: nextId,
            //@ts-ignore
            message: '',
            query: nextContent,
            conversation_key: currentConversation.key,
            type: prompts?.id || '',
        };
        if (props.modelType === ModelType.CUSTOMER_SERVICE_ASSISTANT && currentConversation?.type !== ModelType.CUSTOMER_SERVICE_ASSISTANT && userInfo?.success && userInfo.username === 'GUEST') {
            //@ts-ignore
            aiMessage.auth = 'none';
            aiMessage.status = 'complete';
        }
        const newMessages = [...messages, {
            //@ts-ignore
            role: "local",
            //@ts-ignore
            status: 'complete',
            id: 'msg_' + activeKey + len,
            //@ts-ignore
            message: nextContent,
            type: prompts?.id || '',
            conversation_key: currentConversation.key,
        }, {...aiMessage}];
        //@ts-ignore
        setMessages(newMessages);
        if (currentConversation.message && !currentConversation.message.length) {
            const newCurrentConversation: typeof defaultConversationsItem = cloneDeep(currentConversation);
            //@ts-ignore
            newCurrentConversation.message = newMessages;
            setCurrentConversation(newCurrentConversation);
            setActiveKey(currentConversation.key);
        }
        setLoading(true);
        setCurrentMsg({
            message: '',
            status: '',
            id: '',
            message_id: '',
            conversation_id: '',
            type: prompts?.id || '',
            conversation_key: '',
        });
        setClickCurrentModel(null);
        //@ts-ignore
        if (aiMessage.auth === 'none') {
            setLoading(false);
        } else {
            createRequest(nextContent, nextId);
        }
        setContent('');
    };

    const onWelcomePromptsItemClick: GetProp<typeof Prompts, 'onItemClick'> = (info) => {
        const len = messages.length;
        const nextId = 'msg_' + activeKey + (len + 1);
        setIsFirst(false);
        const aiMessage = {
            //@ts-ignore
            role: "ai",
            //@ts-ignore
            status: 'loading',
            id: nextId,
            //@ts-ignore
            message: '',
            type: prompts?.id || '',
            query: info.data.description,
            conversation_key: currentConversation.key
        };
        if (props.modelType === ModelType.CUSTOMER_SERVICE_ASSISTANT && currentConversation?.type !== ModelType.CUSTOMER_SERVICE_ASSISTANT && userInfo?.success && userInfo.username === 'GUEST') {
            //@ts-ignore
            aiMessage.auth = 'none';
        }
        const newMessages = [...messages, {
            //@ts-ignore
            role: "local",
            //@ts-ignore
            status: 'complete',
            id: 'msg_' + activeKey + len,
            //@ts-ignore
            message: info.data.description,
            type: prompts?.id || '',
            conversation_key: currentConversation.key,
        }, {
            ...aiMessage
        }];
        setActiveKey(currentConversation.key);
        //@ts-ignore
        setMessages(newMessages);
        setClickCurrentModel(null);
        setCurrentMsg({
            message: '',
            status: '',
            id: '',
            message_id: '',
            conversation_id: '',
            type: prompts?.id || '',
            conversation_key: currentConversation.key,
        });
        setLoading(true);
        createRequest(info.data.description as string, nextId);
    };
    const onPromptsItemClick: GetProp<typeof Prompts, 'onItemClick'> = (info) => {
        //@ts-ignore
        if (info.data?.id === prompts?.id) return;
        //@ts-ignore
        setPrompts({id: info.data.id as string, message: info.data.description as string});
    };

    const onConversationClick: GetProp<typeof Conversations, 'onActiveChange'> = (key) => {
        if (key === activeKey) return;
        setActiveKey(key);
        setClickCurrentModel(null);
        let index = 0, flag = false;
        for (const keyElement of conversationsItems) {
            if (keyElement.key === key) {
                flag = true;
                break;
            }
            index++;
        }
        if (flag) {
            setActiveKey(conversationsItems[index].key || '');
            setCurrentConversation(conversationsItems[index]);
            if (conversationsItems[index] && conversationsItems[index].message) {
                setMessages(conversationsItems[index].message);
            }
            if (conversationsItems[index] && conversationsItems[index].senderPromptsItems?.length) {
                const list = conversationsItems[index].senderPromptsItems;
                if (list.length) {
                    const tmp = {
                        id: list[0].id as string,
                        key: list[0].id,
                        label: list[0].description as string,
                        message: list[0].description as string
                    }
                    setPrompts(tmp);
                } else {
                    setPrompts(null);
                }
            }
        }
    };

    const welcomeNode = useMemo(() => {
        return <Space direction="vertical" size={16} className={'chats-placeholder'}>
            <Welcome
                variant="borderless"
                icon={null}
                title={''}
                description={<span
                    className={'welcome-desc'}>{props.modelType === ModelType.CUSTOMER_SERVICE_ASSISTANT && currentConversation?.type !== ModelType.CUSTOMER_SERVICE_ASSISTANT && userInfo?.success && userInfo.username === 'GUEST' ? description[ModelType.NO_AUTH] : description[currentConversation?.type]}</span>}
                extra={null}
            />
            {props.modelType === ModelType.CUSTOMER_SERVICE_ASSISTANT && currentConversation?.type !== ModelType.CUSTOMER_SERVICE_ASSISTANT && userInfo?.success && userInfo.username === 'GUEST' ? null : (placeholderPromptsItems[prompts?.id as string] || placeholderPromptsItems[currentConversation?.type]) ?
                <Prompts className={'welcome-prompts'}
                         title={''}
                         items={placeholderPromptsItems[prompts?.id as string] || placeholderPromptsItems[currentConversation?.type]}
                         styles={{
                             list: {
                                 width: '100%',
                             },
                             item: {
                                 flex: 1,
                             },
                         }}
                         onItemClick={onWelcomePromptsItemClick}
                /> : null
            }
        </Space>;
    }, [currentConversation?.type, prompts?.id]);

    const deleteConversationHandle = (conversation: typeof defaultConversationsItem) => {
        const callback = () => {
            let cloneList = cloneDeep(conversationsItems);
            let i = 0,
                flag = false;
            for (const item of cloneList) {
                if (item.id === conversation.id) {
                    flag = true;
                    break;
                }
                i++;
            }
            if (flag) {
                cloneList.splice(i, 1);
                setConversationsItems(cloneList);
                const cloneDefault = cloneDeep(defaultConversationsItem);
                cloneDefault.key = String(Math.floor(Math.random() * 10240));
                setCurrentConversation(cloneDefault);
                setClickCurrentModel(cloneDefault.type);
                setActiveKey('');
                setMessages([]);
                localStorage.setItem('conversation-list-assistant', JSON.stringify(cloneList));
                //@ts-ignore
                Toast.info(t('success'));
            }
        }
        confirmHandle('删除对话记录', '此操作将永久删除您创建的所有聊天记录，且无法撤销。' +
            '请确认以继续。', callback);
    };
    const usePlaceholder = useMemo(() => {
        const defaultPlaceholder: any = {
            [ModelTypeID.ASSISTANT_NEW]: "您好，我是AI辅导员，请问需要什么帮助？",
            [ModelTypeID.HEAD_TEACHER_NEW]: "您好，我是AI职小班，请问需要什么帮助？"
        };
        return defaultPlaceholder[currentConversation?.typeId] || '';
    }, [currentConversation?.typeId]);
    const userPrompts = useMemo(() => {
        return currentConversation?.senderPromptsItems.map((item: any) => <span
            className={'sender-prompts-item ' + (prompts?.id === item.id ? 'active' : '')} key={item.key || item.id}
            onClick={() => onPromptsItemClick({data: item})}>{item.label}</span>);
    }, [currentConversation?.senderPromptsItems, prompts?.id]);
    const onAddConversation = (type: ModelType, item: ModelItemType) => {
        setIsFirst(true);
        setClickCurrentModel(type);
        const message: any[] = [];
        const newCurr: typeof defaultConversationsItem = {
            key: `${Math.floor(Math.random() * 10240)}`,
            id: `${conversationsItems.length}`,
            label: `${t('newConversation')} ${conversationsItems.length > 0 ? conversationsItems.length : ''}`,
            type,
            //@ts-ignore
            typeId: item.modelTypeId || item.type,
            senderPromptsItems: [],
            // @ts-ignore
            message,
        };
        setMessages([]);
        setActiveKey(newCurr.key);
        setCurrentConversation(newCurr);
    };
    // ==================== Nodes ====================
    const chooseModel = useMemo(() => <div className={'choose-model'}
                                           style={props.modelTypeId === ModelTypeID.COMMUNIST_PARTY_SECRETARY ? {height: 200} : {}}>
        {
            modelList.map(item => <div key={item.key} onClick={() => onAddConversation(item.type, item)}
                                       className={'choose-model-item' + (clickCurrentModel === item.type ? ' active' : '')}>
                <i className={'model-icon ' + item.class}></i>
                <span className={'title'}>{item.message}</span>
            </div>)
        }
    </div>, [modelList, clickCurrentModel]);

    return (
        <div className={'assistant-new chats-layout'}>
            <div className={'chats-menu'}>
                {/* 🌟 logo */}
                <div className={'chats-logo'}>
                    <img
                        src={props.modelTypeId === ModelTypeID.CUSTOMER_SERVICE_ASSISTANT ? AIAssistantLogo : props.modelTypeId === ModelTypeID.COMMUNIST_PARTY_SECRETARY ? AILogoRed : AILogo}
                        draggable={false} alt="logo"/>
                    <span>{t(props.modelTypeId === ModelTypeID.CUSTOMER_SERVICE_ASSISTANT ? 'newAiHeadTeacher.title' : props.modelTypeId === ModelTypeID.COMMUNIST_PARTY_SECRETARY ? 'communistPartySecretary.name' : 'assistant_new.title')}</span>
                </div>
                {/* 模型选择 */}
                {chooseModel}
                {/* 🌟 会话管理 */}
                <div className={'recent-conversations'}>
                    <span className={'title'}>{t('recentConversations')}</span>
                    <Conversations
                        style={props.modelTypeId === ModelTypeID.HEAD_TEACHER_NEW ? {maxHeight: 'calc(100vh - 460px)'} : props.modelTypeId === ModelTypeID.COMMUNIST_PARTY_SECRETARY ? {
                            height: 'calc(100vh - 390px)',
                            maxHeight: "none"
                        } : !props.showLogin ? {height: 'calc(100vh - 630px)'} : {}}
                        items={conversationsItems}
                        className={'chats-conversations'}
                        activeKey={currentConversation.key}
                        onActiveChange={onConversationClick}
                        menu={(conversation) => {
                            return {
                                trigger: () => <div className={'conversation-item-op'}>
                                    <i onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        deleteConversationHandle(conversation as typeof defaultConversationsItem)
                                    }}
                                       className={'iconfont icon-agent-delete conversation-item-delete'}/>
                                </div>,
                                items: []
                            }
                        }}
                    />
                </div>
                {
                    props.showLogin ? <div className={'login-user-info'}>
                        <div className={'user-info'}>
                            <img src={Avatar} alt={''}/>
                            <Dropdown menu={userInfo?.success && userInfo.username === 'GUEST' ? {
                                items: [{
                                    key: '1',
                                    label: t('login')
                                }],
                                onClick: () => {
                                    window.location.href = URL.login + encodeURIComponent(window.location.href);
                                }
                            } as MenuProps : {
                                items:
                                    [{
                                        key: '2',
                                        label: t('logout')
                                    }],
                                onClick: () => {
                                    window.location.href = URL.logout;
                                }
                            } as MenuProps}>
                            <span
                                className={'user-name'}>{userInfo?.success && userInfo.username === 'GUEST' ? userInfo.username : userInfo.screenName} </span>
                            </Dropdown>
                        </div>
                    </div> : null
                }
            </div>
            <div className={'agent-user'}>
                <img style={props.modelTypeId === ModelTypeID.CUSTOMER_SERVICE_ASSISTANT ? {
                    width: 200,
                    height: 200
                } : props.modelTypeId === ModelTypeID.COMMUNIST_PARTY_SECRETARY ? {width: 300} : {
                    width: 140,
                    height: 272
                }}
                     src={props.modelTypeId === ModelTypeID.CUSTOMER_SERVICE_ASSISTANT ? AgentAssistantBG : props.modelTypeId === ModelTypeID.COMMUNIST_PARTY_SECRETARY ? AgentPartyBG : AgentMan}
                     alt={'agent-user'}/>
            </div>
            <div className={'chats-chat'}>
                {/* 🌟 消息列表 */}
                <Bubble.List
                    key={currentConversation.key}
                    items={currentConversation?.message?.length > 0 ? currentConversation?.message : [{
                        content: welcomeNode,
                        variant: 'borderless',
                        avatar: {
                            icon: <CatAIIcon
                                type={props.modelTypeId === ModelTypeID.CUSTOMER_SERVICE_ASSISTANT ? 1 : props.modelTypeId === ModelTypeID.COMMUNIST_PARTY_SECRETARY ? 2 : 0}/>
                        },
                    }]}
                    roles={roles}
                    className={'chats-messages'}
                />
                {/* 🌟 提示词 */}
                <div className={'sender-prompts-items'}>
                    {
                        userPrompts
                    }
                </div>
                {/* 🌟 输入框 */}
                <Sender
                    placeholder={usePlaceholder}
                    value={content}
                    footer={null}
                    onSubmit={onSubmit}
                    onChange={setContent}
                    loading={loading}
                    className={'chats-sender'}
                />
            </div>
        </div>
    );
};
export default Chats;
